export default __webpack_public_path__ + "static/media/sp-im-boy.0040c85d.webp";